import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { StorageService } from '@core/services/storage.service'
import { catchError, Observable, throwError } from 'rxjs'
import { Router } from '@angular/router'
import { AlertService } from '@core/services/alert.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    public storage = inject(StorageService)
    public router = inject(Router)
    public alert = inject(AlertService)
  intercept(
    request: HttpRequest<Request>,
    next: HttpHandler
  ): Observable<HttpEvent<Event>> {
    // const authenticationService = inject(AuthenticationService)
    // Check if the request has the 'skipInterceptor' header
    if (request.headers.has('skipInterceptor')) {
      const newHeaders = request.headers.delete('skipInterceptor'); // Remove the custom header
      const clonedReq = request.clone({ headers: newHeaders });
      return next.handle(clonedReq);
    }
    const token = this.storage.get("auth")
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token.access_token}`,
        },
      })
    }

    // return next.handle(request)
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
          
          if (error && error.status === 401 && !window.location.href.includes('auth')) {
            sessionStorage.clear();
            localStorage.clear();
            this.alert.showError("Sesi anda telah berakhir. Sila log masuk semula.")
            this.router.navigate(["auth"]);

          }
          return throwError(error);
        })
  );
  }
}
